import { render, staticRenderFns } from "./GameRulesView.vue?vue&type=template&id=7f7ab74e&scoped=true"
import script from "./GameRulesView.vue?vue&type=script&lang=js"
export * from "./GameRulesView.vue?vue&type=script&lang=js"
import style0 from "./GameRulesView.vue?vue&type=style&index=0&id=7f7ab74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ab74e",
  null
  
)

export default component.exports